import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Button,
  Image,
  Text,
  Badge,
  Divider,
  Spinner,
} from "@chakra-ui/react";
import { useParams, Link } from "react-router-dom";
import { FaSync, FaPrint } from 'react-icons/fa';
import { BASE_URL } from "../../Globalapi/Globalapi";

const GuardianDetails = () => {
  const { id } = useParams(); // Retrieve user_id from URL parameters
  const [guardianData, setGuardianData] = useState(null);
  const [studentsData, setStudentsData] = useState([]); // State for students data
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGuardianDetails = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/guardian/view_guardian.php?user_id=${id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        console.log("Fetched Data:", data); // Log the entire response for debugging

        if (data.status === 'success') {
          // Set guardian data and filter out students into separate array
          setGuardianData(data.data[0]); // First guardian object
          const students = data.data.map(student => ({
            name: student.studentname,
            class: student.class,
            id: student.student_user_id,
            guardian_id: student.guardian_id,
          }));
          setStudentsData(students);
          console.log("Guardian Data:", data.data[0]); // Log guardian data
          console.log("Students Data:", students); // Log students data
        } else {
          console.error("Error:", data.message);
        }
      } catch (error) {
        console.error("Error fetching guardian details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGuardianDetails();
  }, [id]);

  if (loading) {
    return (
      <Box p={4} textAlign="center">
        <Spinner /> Loading...
      </Box>
    );
  }

  if (!guardianData) {
    return (
      <Box p={4} textAlign="center">
        No guardian data found.
      </Box>
    );
  }

  return (
    <Box bg="white" p={5} borderRadius="md" shadow="md">
      <div className="guardian-list-container">
        <div className="header" style={{ display: 'flex', alignItems: 'center' }}>
          <h1 style={{ fontSize: '20px', margin: 0 }}>Guardian Profile</h1>
          <div className="action-buttons" style={{ marginLeft: 'auto' }}>
            <Button
              className="refresh-button"
              boxShadow="md"
              backgroundColor='white'
              fontSize='11px'
              onClick={() => {
                // Refresh logic can be implemented here
                console.log('Refresh button clicked');
              }}
              display={{ base: 'none', md: 'flex' }}
            >
              <FaSync color='#515B73' />
            </Button>
            <div className="export-dropdown">
              <Button className="export-button" display={{ base: 'none', md: 'flex' }}
                backgroundColor='white' fontSize='11px' boxShadow="md">
                <FaPrint color='#515B73' />
                Print PDF
              </Button>
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link to="/admin" style={{ textDecoration: 'none', color: 'inherit' }}>
            <span>Dashboard</span>
          </Link> /
          <Link to="/guardian/list" style={{ textDecoration: 'none', color: 'inherit' }}>
            <span> Guardian List</span>
          </Link> / <span>Guardian Profile</span>
        </Box>

        <Box p={4} mt={4}>
          <Grid templateColumns={{ base: "1fr", md: "1fr 3fr" }} gap={6}>
            <GridItem>
              <Box
                p={4}
                borderWidth="1px"
                borderRadius="lg"
                bg="gray.50"
                _hover={{ shadow: "lg" }}
                transition="all 0.3s ease"
                maxW="100%"
                overflow="hidden"
                minW={{ base: "none", md: "400px" }}
              >
                <Flex alignItems="center" mb={4} direction={{ base: "column", md: "row" }}>
                  <Image
                    src={guardianData.image_url || "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg"}
                    alt="Guardian"
                    borderRadius="full"
                    boxSize={{ base: "60px", md: "80px" }}
                    objectFit="cover"
                    onError={(e) => {
                      e.target.src = "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg";
                    }}
                    mb={{ base: 2, md: 0 }}
                  />
                  <Box ml={{ md: 4 }} textAlign={{ base: "center", md: "left" }}>
                    <Text fontWeight="bold" fontSize={{ base: "md", md: "lg" }}>
                      {guardianData.name}
                    </Text>
                    <Text fontSize="sm" color="gray.600">
                      Username: {guardianData.username}
                    </Text>
                    <Badge colorScheme="green" mt={1}>
                      Guardian
                    </Badge>
                  </Box>
                </Flex>
                <Divider my={4} />
                <Box>
                  <Flex wrap="wrap" direction="row" justifyContent="space-between">
                    <Box mb={2} minW="120px">
                      <Text fontWeight="bold">Phone No:</Text>
                      <Text>{guardianData.phone_no}</Text>
                    </Box>
                    <Box mb={2} minW="120px">
                      <Text fontWeight="bold">Email:</Text>
                      <Text>{guardianData.email}</Text>
                    </Box>
                    <Box mb={2} minW="120px">
                      <Text fontWeight="bold">Address:</Text>
                      <Text>{guardianData.address}</Text>
                    </Box>
                    <Box mb={2} minW="120px">
                      <Text fontWeight="bold">Relationship:</Text>
                      <Text>{guardianData.relationship}</Text>
                    </Box>
                    <Box mb={2} minW="120px">
                      <Text fontWeight="bold">Date Of Birth:</Text>
                      <Text>{guardianData.date_of_birth}</Text>
                    </Box>
                  </Flex>
                </Box>
              </Box>
            </GridItem>

            <GridItem>
              <Box
                p={4}
                borderWidth="1px"
                borderRadius="lg"
                bg="gray.50"
                shadow="md"
                _hover={{ shadow: "lg" }}
                transition="all 0.3s ease"
                mb={4}
              >
                <Text mb={2} fontWeight="bold" fontSize="lg">
                  Additional Information
                </Text>
                <Text>Occupation: {guardianData.occupation}</Text>
                <Text>Employer: {guardianData.employer}</Text>
              </Box>

              {/* Displaying Students */}
              <Box mt={4}>
                <Text fontWeight="bold" fontSize="lg" mb={2}>
                  Students
                </Text>
                {studentsData.length > 0 ? (
                  <Box>
                    {studentsData.map((student) => (
                      <Box key={student.id} p={2} borderWidth="1px" borderRadius="md" bg="gray.100" mb={2}>
                        <Link
                      to={`/students/detail/${student.id}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                        <Text fontWeight="bold">{student.name}</Text>
                        </Link>
                        <Text>Class: {student.class}</Text>
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Text>No students found for this guardian.</Text>
                )}
              </Box>
            </GridItem>
          </Grid>
        </Box>
      </div>
    </Box>
  );
};

export default GuardianDetails;
